<template>
    <el-popover
        placement="bottom-start"
        popper-class="popover-trigger"
        width="300"
        v-model="visible"
        trigger="manual"
    >
        <div class="popover-sure">
            <div class="clearfix">
                <i
                    class="iconfont icon-chachaicon deleteIcon"
                    @click="handleCancel"
                ></i>
            </div>
            <div class="popTitle">
                <i class="iconfont icon-jinggaotanhaoicon"></i>
                <span>{{title}}</span>
            </div>
            <div
                class="popText"
                v-if='text'
            >{{text}}</div>
            <div class="popBtn">
                <el-button
                    size="mini"
                    @click="handleSure"
                >确 认</el-button>
                <el-button
                    size="mini"
                    @click="handleCancel"
                >取 消</el-button>
            </div>
        </div>
        <span
            slot="reference"
            @click.stop="visible = true"
        >
            <slot name="content"></slot>
        </span>
    </el-popover>
</template>

<style lang='scss' rel='stylesheet/scss'>
.popover-trigger {
    .popover-sure {
        .deleteIcon {
            float: right;
            color: red;
            font-size: 12px;
            color: #ccc;
            height: 12px;
            cursor: pointer;
        }
        .icon-jinggaotanhaoicon {
            color: #ff9b54;
            font-size: 20px;
        }
        .popTitle {
            padding: 0 22px;
            line-height: 20px;
            .iconfont {
                margin-right: 6px;
            }
            span {
                font-size: 14px;
                color: #333333;
                font-weight: 600;
            }
            .iconfont,
            span {
                vertical-align: middle;
            }
        }
        .popText {
            font-size: 12px;
            color: #666666;
            padding: 10px 32px 0 52px;
        }
        .popBtn {
            text-align: center;
            margin: 18px 0 6px 0;
            .el-button {
                background: #ffffff;
                border: 1px solid $color-primary;
                color: $color-primary;
                border-radius: 3px;
                width: 90px;
                height: 26px;
                font-size: 14px;
                line-height: 1px;
            }
        }
    }
}
</style>

<script>

export default {
    props: {
        title: {
            type: String
        },
        text: {
            type: String
        }
    },
    data () {
        return {
            visible: false
        }
    },
    computed: {

    },
    methods: {
        handleSure () {
            this.$emit('sureFunction')
            this.visible = false
        },
        handleCancel () {
            this.$emit('cancelFunction')
            this.visible = false
        }
    },
    created () {

    }
}
</script>
